import { Modal, Row, Button, Col } from "react-bootstrap";

const API_BASE_URL = "https://investin-api.javatimescaffe.com/";

const getFileUrl = (file) => {
  if (!file) return "";
  if (/^https?:\/\//i.test(file)) return file;

  const normalizedFile = String(file).replace(/\\/g, "/");
  const uploadIndex = normalizedFile.lastIndexOf("/upload/");

  if (uploadIndex >= 0) {
    return `${API_BASE_URL}${normalizedFile.slice(uploadIndex + 1)}`;
  }

  const cleanedFile = normalizedFile.replace(/^\.\//, "").replace(/^\/+/, "");
  return `${API_BASE_URL}${cleanedFile}`;
};

const isImageFile = (file) => /\.(png|jpe?g|gif|webp|svg)$/i.test(file || "");
const isPdfFile = (file) => /\.pdf($|\?)/i.test(file || "");

const WithdrawlReceiptModal = ({ status, toggleModal, data, title = "Withdrawl File" }) => {
  const fileUrl = getFileUrl(data?.file);

  return (
    <Modal
      show={status}
      onHide={toggleModal}
      centered
      size="lg"
      className="invest-options-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div>
            <h4>{title}</h4>
            {fileUrl ? (
              <Button className="lp-btn mt-4" variant="outline-danger" type="button">
                <a href={fileUrl} target="_blank" rel="noopener noreferrer" download>
                  Download Now
                </a>
              </Button>
            ) : null}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {fileUrl ? (
          <Row>
            <Col>
              {isImageFile(fileUrl) ? (
                <img
                  src={fileUrl}
                  alt={title}
                  style={{ width: "100%", maxHeight: "70vh", objectFit: "contain" }}
                />
              ) : isPdfFile(fileUrl) ? (
                <iframe
                  src={fileUrl}
                  title={title}
                  style={{ width: "100%", height: "70vh", border: 0 }}
                />
              ) : (
                <div style={{ padding: "1rem", textAlign: "center" }}>
                  Preview is not available for this file type. Use download to open it.
                </div>
              )}
            </Col>
          </Row>
        ) : (
          <div style={{ padding: "1rem", textAlign: "center" }}>No file available.</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default WithdrawlReceiptModal;
